<template>
  <div>
    <el-dialog
      v-if="visible"
      :visible="visible"
      :title="title"
      show-close
      width="880px"
      :close-on-click-modal="false"
      :before-close="() => cancel()"
      v-el-dialog-drag
      append-to-body
    >
      <Main
        ref="main"
        :disabled="disabled"
        :data="data"
        @reload="$emit('reload')"
        @close="close()"
      />
      <span slot="footer">
        <el-button size="small" @click="cancel()">
          {{ this.$l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="save()" v-if="!disabled">
          {{ this.$l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const noop = async () => true
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    data: { type: Object, default: () => {} },
    beforeSave: { type: Function, default: noop },
    saveRequest: { type: Function, default: noop },
  },
  data() {
    return {
      backDialogVisible: false,
    }
  },
  methods: {
    async save() {
      await this.beforeSave()
      const formData = await this.$refs.main.getFormData()
      if (!formData) return
      if (!(await this.saveRequest(formData))) return
      this.close()
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
